export default function (state) {
    state.loading =  false;
    state.tab = 'form';
}